import React from 'react';
import styles from './styles.module.css';
import SideBarCard from './SideBarCard';
import { Blog, Tags } from '@/commonTypes';
import AppLink from '@/components/common/AppLink';
import BadgeCard from '@/components/general/BadgeCard';
import MainIcons from '@/icons/main';
import { useTranslations } from 'next-intl';
import Popular_blogs from '../popular_blog/Popular_blogs';
import BannerCta from '@/components/general/BannerCta';
import PageCardHeader from '@/components/general/PageCard/PageCardHeader';
import { avatarBg } from '@/functions/formats';
import BlogsBanner from '../BlogsBanner';
import BlogTags from '../../SingleBlogContent/BlogTags';

export default function BlogsAside({
  popularBlogs,
  tags,
  tagSlug,
}: {
  popularBlogs?: Blog[];
  tags?: Tags[];
  tagSlug?: string | null;
}) {
  const tCommon = useTranslations('common');
  return (
    <aside className={`${styles.sidebar}`}>
      <SideBarCard
        title={tCommon('mostViewed')}
        icon={<MainIcons.fireIcon fill="var(--accent)" width="19px" height="19px" />}
      >
        {popularBlogs?.map((item, index) => (
          <Popular_blogs key={index} popularBlog={item} index={index} />
        ))}
      </SideBarCard>
      <BlogsBanner />
      <SideBarCard title={tCommon('popularTags')} icon={<MainIcons.tagIcon />}>
        <BlogTags tags={tags} tagSlug={tagSlug} />
      </SideBarCard>
    </aside>
  );
}
